// extracted by mini-css-extract-plugin
module.exports = {"piece":"Piece_piece__OP3On","h2":"Piece_h2__KuKRs","logoContainer":"Piece_logoContainer__qSCzf"};